import React from 'react'

const UserFillIcon16pxSvg = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path d="M2.99823 14.3262C2.99823 14.3262 1.99823 14.3262 1.99823 13.3262C1.99823 12.3262 2.99823 9.32625 7.99823 9.32625C12.9982 9.32625 13.9982 12.3262 13.9982 13.3262C13.9982 14.3262 12.9982 14.3262 12.9982 14.3262H2.99823ZM7.99823 8.32625C8.79388 8.32625 9.55694 8.01018 10.1196 7.44757C10.6822 6.88496 10.9982 6.1219 10.9982 5.32625C10.9982 4.5306 10.6822 3.76754 10.1196 3.20493C9.55694 2.64232 8.79388 2.32625 7.99823 2.32625C7.20258 2.32625 6.43952 2.64232 5.87691 3.20493C5.3143 3.76754 4.99823 4.5306 4.99823 5.32625C4.99823 6.1219 5.3143 6.88496 5.87691 7.44757C6.43952 8.01018 7.20258 8.32625 7.99823 8.32625Z" fill="currentColor" />
        </svg>
    )
}

export default UserFillIcon16pxSvg